export default {
  profile: {
    title: "My Profile",
    info: "Here you can edit your information, see your booked and applied meeting times and the companies you have interested yourself in.",
    firstname: "First Name",
    lastname: "Last Name",
    dateOfBirth: "Birthyear",
    email: "Email",
    phone: "Phone number",
    school: "School",
    program: "Program/Course",
    graduationYear: "Graduation Year",
    linkedIn: "LinkedIn",
    cv: "CV",
    uploadCV: "Upload CV",
    interestedCompanies: "Interested Companies",
    appliedContactMeetings: "Applied contact meeting times",
    schools: {
      sh: "Södertörn university",
      other: "Other",
    },
    programs: {
      economics: "Economics bachelor",
      interEconomics: "International Business and Economics",
      tourism: "Tourism program",
      artCultureEconomy: "Art, Culture and Economy",
      logisticsEconomy: "Logistics and Economics",
      econTechDesign: "Economics, Technology and Design",
      managementIT: "Management with IT",
      entrepreneurship: "Entrepreneurship, Innovation and Marketing",
      europeanStudies: "European Studies Program",
      ppeProgram: "Philosophy, Politics and Economics",
      interculturalBusiness: "Intercultural Enterprise",
      sportManagement: "Sport management",
      journalism: "Journalism program",
      teacher: "Teacher program",
      otherProgram: "Other program",
      course: "Standalone course(s)",
    },
    unsavedChanges: "Unsaved changes",
    noInterestedCompanies:
      "You have not interested yourself in any companies yet",
    bookedContactMeetings: "Booked contact meetings",
    bookingUnavailable: "This time can not be booked",
    noBookedMeetings: "No meetings booked yet",
    noAppliedMeetings: "No meetings applied to yet",
    sameTimeBooking:
      "You have a meeting booked at the same time with another company",
    sameCompanyBooking: "You have another meeting booked with",
    otherPersonBooking: "Someone else has booked the time",
    with: "with",
  },
  company: {
    company: "Company",
    featured: "Exhibitors with contact meetings",
    all: "All exhibitors",
    readMore: "Read More",
    founded: "Founded",
    employees: "Employees in Sweden",
    locations: "Locations",
    about: "About Us",
    values: "Our Values",
    name: "Name",
    tags: "Tags",
    interested: "Interested",
    notInterested: "Not interested",
    contactMeeting: "Contact meeting",
    applyContactMeeting: "Apply for contact meeting",
    chooseTimes: "Apply for time slots",
    removeAppliedTimes: "Remove applied times",
    cancelRemoval: "Cancel removal",
    removeTimes: "Remove times",
    availableTimes: "Available times",
    downloadCv: "Download CV",
    interestRemoved: "Interest removed",
    interestSaved: "Interest saved",
    addCompany: "Add company",
    meetingRoom: "Meeting room",
    intro: {
      readAbout:
        'Here you can read about the companies at the fair by clicking on "{readMore}", apply for contact meetings with some of the exhibitors by clicking on "{requestMeeting}", and show interest in an exhibitor by clicking on "{interested}".',
      contactMeeting:
        "You can request a meeting by logging in and adding information to your profile. Then you apply for the time slots that you would be available to meet the companies you are interested in. Once you have submitted your requests, you can view them in your profile. A company representative will review your request and hopefully approve a time for you!",
      note: "NOTE: Applying for a time does NOT mean that you have a booked meeting, the exhibitors need to ACCEPT one of your applications. You cannot have more than one meeting booked with the same company, and also you cannot have multiple meetings booked at the same time.",
    },
    contactMeetingCardInfo:
      'Here you apply fo contact meetings. Apply for times by marking times and then clicking "Apply". Remove applied times by clicking "Remove applied times" and then clicking "Remove times".',
    applyingNote:
      "NOTE: Times you apply for are NOT booked, the company has to ACCEPT the application. When a meeting gets booked you get a confirmation on your email.",
    noTimes: "Contact meeting times will be published soon",
  },
  common: {
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    cancelAll: "Cancel changes",
    notSelected: "Not selected",
    saveAll: "Save all",
    close: "Close",
    apply: "Apply",
    and: "and",
    remove: "Remove",
    goTo: "Go to",
    bookMeeting: "Book meeting",
    cancelMeeting: "Cancel meeting",
    either: "Either",
    date: "Date",
    time: "Time",
    madeBy: "Made by",
  },
  success: {
    profileUpdated: "Profile updated!",
    cvUploaded: "CV uploaded!",
    timesRemoved: "Times removed!",
    contactMeetingApplied: "Contact meeting times applied!",
    companySaved: "Company saved",
    bookMeeting: "Meeting booked",
    cancelMeeting: "Meeting canceled",
    employeeAdded: "Employee added",
    changePassword: "Successfully changed password!",
  },
  errors: {
    somethingWentWrong: "Something went wrong",
    tryAgainLater: "Try again later",
    fetchProfile: "Could not fetch profile info.",
    saveField: "Could not save the change.",
    cvUpload: "CV upload failed.",
    register: {
      emailExists: "Email already exists",
      serverError: "An error occurred during registration",
      default: "Registration failed",
    },
    signedIn: "You need to be signed in",
    removeTimes: "Could not remove times",
    applyTimes: "Could not apply for times",
    notFoundPage: {
      pageDoesntExist: "Page does not exist",
      couldntBeFound:
        "Unfortunately, the page you are looking for could not be found",
      homePage: "Go to the homepage",
    },
    companySaved: "Company could not be saved",
    acceptTermsLogin:
      "You need to accept the Privacy Policy and Terms of Use to log in",
    acceptTermsRegister:
      "You need to accept the Privacy Policy and Terms of Use to register",
    bookMeeting: "Could not book meeting",
    cancelMeeting: "Could not cancel meeting",
    fillAllFields: "You need to fill all fields",
    changePassword: "Not able to change password",
    signOutAndIn: "Try signing out and then signing in again",
  },
  language: {
    sv: "Svenska",
    en: "English",
    date: "en-GB",
  },
  header: {
    homePage: "Home",
    profile: "Profile",
    exhibitors: "Exhibitors",
    meetings: "Meetings",
  },
  footer: {
    contact: "Contact us",
    address: "Address",
    support: "Support",
    questionContact: "If you have questions, contact:",
  },
  login: {
    login: "Sign in",
    loggedIn: "Signed in",
    logoutQuestion: "Do you want to sign out?",
    logout: "Sign out",
    register: "Register",
    password: "Password",
    accountExist: "Do you already have an account?",
    accountNotExist: "Do you not have an account?",
    loginHere: "Sign in here",
    registerHere: "Register here",
    acceptTerms: "I accept SÖFREs",
    privacyPolicy: "Privacy policy",
    termsOfUse: "Terms of Use",
    changePassword: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    validationRequired: "Validation required",
    passwordLength: "Your password must have five (5) or more characters",
    passwordMatch: "Must match your new password",
  },
  home: {
    intro:
      "e-day is Södertörn University's career fair for economics students. For the twenty-fifth time, Södertörn’s United Economists (SÖFRE) is organizing this fair, offering Södertörn’s students a unique opportunity to meet their future employers. On November 11th, students at Södertörn University will be able to attend this year's edition of SÖFRE’s career fair for economists, e-day.",
    meeting:
      "A contact meeting is an interview between a student and a representative from a participating company at e-day that has chosen to offer such meetings. These interviews are held during e-day and are booked for 25 minutes, including a 20-minute interview and a 5-minute break in between for the company. This gives the company a chance to get to know you and who you are. e-day is also a great opportunity for those looking for a part-time job during their studies or insight into what a career in the economics sector can look like. At the same time, you’ll have the chance to learn more about the company and build valuable connections. You’ll gain insights into their recruitment process and what they look for in newly graduated students.",
    member:
      "Don't miss this chance to market yourself as the workforce of the future to attractive employers! To participate, you must be a member of Södertörn’s United Economists. Membership is free and anyone can join here:",
    memberLink: "http://www.sofre.se/bli-medlem/",
    networking:
      "e-day is a great opportunity to meet new people and network, as well as attend lectures that give you an advantage as a student. Being active during the fair and visiting many of the exhibiting companies increases your chances of securing your future.",
  },
  employee: {
    info: 'Here you can see all the meeting times that students have applied for. Go through each student’s profile and review which students you think would be suitable for a contact meeting with you. You can only book a total of "{availableTimes}". You can also only book one time per student and one student per time slot. Some times cannot be booked; this may be because the student already has a meeting booked with you, the student has another meeting at that time, or you have already booked a meeting with another student at that time. So make sure to carefully choose which students you schedule and which times they get!',
    youHave: "You have",
    freeTimes: "free times",
    bookedMeetings: "booked meetings",
    applicants: "Studentes applying for meetings",
    applicantsInfo:
      'Below you can see all students who have applied for contact meetings with you. Read through their profiles and book a meeting with a student by clicking "BOOK MEETING". When a meeting gets booked the student gets an automatic confirmation email.',
    meetingTimes: "Meeting times",
    bookingUnavailable: "Not possible to book",
    book: "book",
    cancel: "cancel",
    confirmCancelation: "Confirm cancelation",
    confirmBooking: "Confirm booking",
    areYouSure: "Are you sure you want to",
    meetingWith: "the meeting with",
    the: "the",
    at: "at",
    bookingNotPossible: "Why is it not possible to book",
    alreadyBooked: "The student already has a booked meeting with your company",
    timeUnavailable: "You have booked the time with another student",
    studentUnavailable:
      "The student is unavailable due to another meeting at that time",
    addEmployee: "Add employee",
  },
};
